import { FormationDetailProps } from '@/types/formation';

export const preCatecFormation: FormationDetailProps = {
  id: '30',
  title: 'Formation Pré-CATEC®',
  description: 'Acquisition des prérequis obligatoires avant la formation CATEC® dans les métiers de l\'eau et de l\'assainissement R472 R447',
  duration: '7h (1 jour)',
  category: 'Sécurité',
  imageSrc: '/images/formations/catec.webp',
  slug: 'pre-catec',
  reference: 'R472 R447-PRE',
  price: 'Sur devis – nous contacter',
  habilitation: 'Sous habilitation N° H30797/2023/Catec-1/0/16',

  // Détails supplémentaires
  objectives: [
    'Acquérir les prérequis exigés pour accéder à la formation CATEC®',
    'Connaître les règles de signalisation et de balisage de chantier',
    'Savoir utiliser et interpréter un contrôleur d\'atmosphère',
    'Utiliser correctement les appareils respiratoires et les EPI'
  ],

  targetAudience: 'Salariés, surveillants et intervenants devant suivre la formation CATEC® et ne disposant pas des prérequis attestés par leur employeur',

  prerequisites: [
    'Être âgé de 18 ans',
    'Être apte médicalement',
    'Tenue de travail et EPI obligatoires'
  ],

  program: [
    {
      title: 'Théorie',
      items: [
        'Contexte réglementaire et recommandations R472 et R447 de la CNAM',
        'Notions sur la signalisation temporaire de chantier',
        'Principes de détection des gaz et seuils d\'alarme',
        'Rôle et limites des appareils respiratoires et des EPI'
      ]
    },
    {
      title: 'Pratique',
      items: [
        'Mise en place d\'une signalisation et d\'un balisage de chantier',
        'Mise en service, vérification et interprétation d\'un contrôleur d\'atmosphère',
        'Mise en œuvre des appareils respiratoires (autosauveteur, ARI)',
        'Port et vérification des EPI (harnais, casque, etc.)'
      ]
    }
  ],

  evaluationMethods: [
    'Questionnaire de positionnement initial',
    'Exercices pratiques en conditions réelles',
    'QCM d\'évaluation des acquis',
    'Évaluation de satisfaction à chaud'
  ],

  certification: 'Attestation de validation des prérequis permettant l\'accès à la formation CATEC®',

  pedagogicalMethods: [
    '40% théorie, 60% pratique',
    'Exposés didactiques, vidéos, démonstrations',
    'Manipulation des équipements : détecteurs de gaz, appareils respiratoires, EPI, balisage',
    'Suivi des recommandations R447 et R472'
  ],

  accessibilityCriteria: 'La formation est accessible aux personnes en situation de handicap. Merci de nous contacter en amont pour anticiper tout aménagement nécessaire.',

  registrationProcess: [
    'Inscription par email',
    'Délai d\'accès basé sur un agenda interne à l\'entreprise',
    'Inscription possible jusqu\'à 15 jours avant la session'
  ],

  intervenant: 'Les formations CATEC sont réalisées par un organisme habilité par l\'INRS sous l\'habilitation N° H30797/2023/Catec-1/0/16',

  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsiformation.fr'
  }
};

export default preCatecFormation;
